import React from 'react';
import { useQuery } from 'react-apollo-hooks';
import Editor from '../../../components/Editor';
import { ErrorScreen, Loading } from '../../../components/utils';
import { noteQuery } from '../../../queries/notes';
import { EditorProvider } from '../../../components/Editor/EditorContext';

const NoteEdit: React.FC<{ noteId: string }> = ({ noteId }) => {
  const { data, loading, error } = useQuery(noteQuery, { variables: { id: noteId } });
  if (loading) return <Loading />;
  if (error) return <ErrorScreen error={error.message} />;

  const { note } = data;

  return (
    <EditorProvider entry={note}>
      <Editor />
    </EditorProvider>
  );
};

export default NoteEdit;
